export default __webpack_public_path__ + "static/media/Img2.6ec38908.jpg";